/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账目</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-form-item label="" prop="entryTime">
          <div class="block">
            <el-date-picker
              v-model="formInline.queryDate"
              type="daterange"
              size="small"
              style="width: 300px"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.manualStaffName" placeholder="请求输入员工名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.manualCategory" placeholder="请选择项目类别"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.isNewCustomer" placeholder="顾客类型">
          <el-option v-for="type in isNewCustomerEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.isFavorableComment" placeholder="好评">
          <el-option v-for="type in isFavorableCommentEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="dataExport()">数据导出</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="dataImport()">数据导入</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">手工录账</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="manualDate" label="日期" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.manualDate)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="manualStaffName" label="员工" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="customerName" label="客户" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="manualCategory" label="类别" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="manualContent" label="项目内容" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="manualAmount" label="金额" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="newCardAmount" label="办卡金额" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="newCardProportion" label="办卡比例" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="rechargeCardAmount" label="充值金额" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="rechargeCardProportion" label="充值比例" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="isMember" label="会员" width="70" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{isMemberFormat(scope.row.isMember)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="isOldCustomer" label="新顾客" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{isNewCustomerFormat(scope.row.isNewCustomer)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="isFavorableComment" label="好评" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{isFavorableCommentFormat(scope.row.isFavorableComment)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="isReorder" label="翻单" width="70" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.isReorder ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="isDesignated" label="指定" width="70" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.isDesignated ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="refillType" label="免费补睫" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ {1: '普通', 2: '款式'}[scope.row.refillType] || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleManualTrans(scope.row)">预览</el-button>
          <el-button size="mini" type="danger" @click="delManualTrans(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 接龙界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" v-loading.fullscreen.lock="loading" width="90%" @click="closeDialog('editForm')">
      <el-row>
        <el-col :span="17">
          <el-form label-width="10px" :model="editForm" ref="editForm">
            <el-tabs v-model="activeName" style="margin-left: 20px;">
              <el-tab-pane label="流水展示" name="second">
                <el-table :data="solitaireTableData" height="400" border style="width: 100%" >
                  <el-table-column prop="accountDate" label="日期" width="100"></el-table-column>
                  <el-table-column prop="providerName" label="服务员名" width="80"></el-table-column>
                  <el-table-column prop="customerName" label="姓名" width="150"></el-table-column>
                  <el-table-column prop="serviceItem" label="项目" width="160"></el-table-column>
                  <el-table-column prop="itemAmount" label="金额" width="60"></el-table-column>
                  <el-table-column prop="newMembershipCardRechargeAmount" label="开卡金额" width="80"></el-table-column>
                  <el-table-column prop="newMembershipCardDividedInto" label="开卡数量" width="80"></el-table-column>
                  <el-table-column prop="membershipCardRechargeAmount" label="充值金额" width="80"></el-table-column>
                  <el-table-column prop="membershipCardDividedInto" label="充值数量" width="80"></el-table-column>
                  <el-table-column prop="isMember" label="会员" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isMember">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="newConsumer" label="新客户" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isNewConsumer">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isPositiveReviews" label="好评" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isPositiveReviews">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isReorder" label="翻单" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isReorder">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isDesignated" label="指定" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isDesignated">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customerSource" label="来源" width="80"></el-table-column>
                  <el-table-column label="提示" min-width="260">
                    <template slot-scope="scope">
                      <el-alert v-for="(warning, index) in (scope.row.warnings || [])" :key="index"
                                :title="warning" type="warning" :closable="false" show-icon></el-alert>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;" @click="saveSolitaire()" >提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="7">
          <el-form label-width="10px" :model="editForm" ref="editForm">
            <el-form-item prop="content">
              <el-input type="textarea" v-model="solitaire.content" auto-complete="off" :rows="20" placeholder="接龙内容" show-word-limit></el-input>
            </el-form-item>
            <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;" @click="solitaireFormat()" >转换</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 导入功能 -->
    <el-dialog title="账目导入" :visible.sync="importVisible" v-loading.fullscreen.lock="loading" width="28%" @click="closeDialog('editForm')">
      <el-upload
        class="upload-demo"
        drag
        name="excelFile"
        :data="postParm"
        :on-error="uploadFalse"
        :on-success="uploadSuccess"
        :before-upload="beforeAvatarUpload"
        action="api/solitaireFormat/uploadExcel"
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过500kb</div>
      </el-upload>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog title="修改手工信息" :visible.sync="editManualTransVisible" width="60%" @click="closeDialog">
      <el-form label-width="160px" :model="editManualTransForm" :rules="rules" ref="editForm">
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="日期" prop="staffName">
              <el-input size="small" v-model="editManualTransForm.manualDate"  auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="服务员名" prop="wagesCycle">
              <el-input size="small" v-model="editManualTransForm.manualStaffName" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="客户姓名" prop="attendanceNum">
              <el-input size="small" v-model="editManualTransForm.customerName" auto-complete="off" placeholder="请输入客户姓名" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="项目金额" prop="memberHandmadeCommission">
              <el-input size="small" v-model="editManualTransForm.manualAmount" auto-complete="off"  placeholder="请输入项目金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="项目类型" prop="basicSalary">
              <el-input size="small"v-model="editManualTransForm.manualCategory" auto-complete="off" placeholder="请输入项目类型" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="项目内容" prop="ordinaryHandmadeCommission">
              <el-input size="small" v-model="editManualTransForm.manualContent" auto-complete="off"  placeholder="请输入项目内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="开卡金额" prop="newCardCommission">
              <el-input size="small" v-model="editManualTransForm.newCardAmount" auto-complete="off" placeholder="请输入开卡金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开卡数量" prop="rechargeCommission">
              <el-input size="small" v-model="editManualTransForm.newCardProportion" auto-complete="off"  placeholder="请输入开卡比例"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="充值金额" prop="newCardCommission">
              <el-input size="small" v-model="editManualTransForm.rechargeCardAmount" auto-complete="off"  placeholder="请输入充值金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="充值数量" prop="rechargeCommission">
              <el-input size="small" v-model="editManualTransForm.rechargeCardProportion" auto-complete="off"  placeholder="请输入充值数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="来源" prop="basicSalary">
              <el-input size="small"v-model="editManualTransForm.customerSource" auto-complete="off"  placeholder="" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否好评" prop="incomeMethod">
              <el-radio v-model="editManualTransForm.isFavorableComment" :label="true">是</el-radio>
              <el-radio v-model="editManualTransForm.isFavorableComment" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="是否翻单" prop="isReorder">
              <el-radio v-model="editManualTransForm.isReorder" :label="true">是</el-radio>
              <el-radio v-model="editManualTransForm.isReorder" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否指定" prop="isDesignated">
              <el-radio v-model="editManualTransForm.isDesignated" :label="true">是</el-radio>
              <el-radio v-model="editManualTransForm.isDesignated" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="是否会员" prop="incomeMethod">
              <el-radio v-model="editManualTransForm.isMember" :label="true">是</el-radio>
              <el-radio v-model="editManualTransForm.isMember" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否新客户" prop="incomeMethod">
              <el-radio v-model="editManualTransForm.isNewCustomer" :label="true">是</el-radio>
              <el-radio v-model="editManualTransForm.isNewCustomer" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeManualTransDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitManualTranForm()">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="title" :visible.sync="importListVisible" v-loading.fullscreen.lock="loading" width="65%" @click="closeDialog('editForm')">
      <el-row>
        <el-col :span="24">
          <el-form label-width="10px" :model="editForm" ref="editForm">
            <el-tabs v-model="activeName" style="margin-left: 20px;">
              <el-tab-pane label="流水展示" name="second">
                <el-table :data="solitaireTableData" height="400" border style="width: 100%" >
                  <el-table-column prop="accountDate" label="日期" width="100"></el-table-column>
                  <el-table-column prop="providerName" label="服务员名" width="80"></el-table-column>
                  <el-table-column prop="customerName" label="姓名" width="150"></el-table-column>
                  <el-table-column prop="serviceItem" label="项目" width="160"></el-table-column>
                  <el-table-column prop="itemAmount" label="金额" width="60"></el-table-column>
                  <el-table-column prop="newMembershipCardRechargeAmount" label="开卡金额" width="80"></el-table-column>
                  <el-table-column prop="newMembershipCardDividedInto" label="开卡数量" width="80"></el-table-column>
                  <el-table-column prop="membershipCardRechargeAmount" label="充值金额" width="80"></el-table-column>
                  <el-table-column prop="membershipCardDividedInto" label="充值数量" width="80"></el-table-column>
                  <el-table-column prop="isMember" label="会员" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isMember">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="newConsumer" label="新客户" width="70">
                  <template v-slot="scope">

                      <el-tag v-if="scope.row.isNewConsumer">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isPositiveReviews" label="好评" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isPositiveReviews">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isReorder" label="翻单" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isReorder">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isDesignated" label="指定" width="70">
                    <template v-slot="scope">
                      <el-tag v-if="scope.row.isDesignated">是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customerSource" label="来源" width="80"></el-table-column>
                  <el-table-column label="提示" min-width="260">
                    <template slot-scope="scope">
                      <el-alert v-for="(warning, index) in (scope.row.warnings || [])" :key="index"
                                :title="warning" type="warning" :closable="false" show-icon></el-alert>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;" @click="saveSolitaire()" >提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
import {
  solitaireFormat,
  OrderRefund,
  OrderDelete,
  saveSolitaire,
  getManualTransPage,
  exportManualTrans, delManualTrans, updateManualTrans
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
import {formatDate} from "../../utils/util";
import {roleDelete} from "../../api/userMG";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      importVisible:false,
      importListVisible:false,
      editManualTransVisible:false,
      editManualTransForm:{
        manualId: null,
        manualDate: null,
        manualStaffId: null,
        manualStaffName:"",
        manualMchId: null,
        customerName: "",
        manualCategory: "",
        manualContent:"",
        manualAmount: null,
        newCardAmount:null,
        newCardProportion:null,
        rechargeCardAmount:null,
        rechargeCardProportion:null,
        isMember: null,
        isNewCustomer:null,
        isFavorableComment:null,
        isReorder:null,
        isDesignated:null,
        customerSource:null,
        newCardTotal:null,
        rechargeCardTotal:null
      },
      activeName: 'second',
      solitaireTableData: [],
      title: '接龙解析',
      open1: false,
      fileList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      postParm:{
        businessName: "设备excel"
      },
      isMemberEnum:[
        { key: '是否会员', value: null },
        { key: '是', value: true },
        { key: '否', value: false }
      ],
      isNewCustomerEnum:[
        { key: '是否新顾客', value: null },
        { key: '是', value: true },
        { key: '否', value: false }
      ],
      isFavorableCommentEnum:[
        { key: '是否好评', value: null },
        { key: '是', value: true },
        { key: '否', value: false }
      ],
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        current: 1,
        size: 10,
        manualDate: null,
        queryDate: null,
        manualStaffName: null,
        manualCategory: null,
        isMember: null,
        isNewCustomer: null,
        isFavorableComment:null,
        customerSource: null,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      solitaire:{
        content:''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取手工流水分页数据
    getdata(parameter) {
      this.loading=true
      getManualTransPage(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.loading=false
            // 分页赋值
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.solitaireTableData=[]
      this.editFormVisible = true
      this.editForm = row
    },
    // 接龙解析
    solitaireFormat() {
      this.loading=true
      // 注释
      solitaireFormat(this.solitaire.content).then(res => {
        if (res.code==='200') {
          this.loading=false
          this.editFormVisible=true
          this.solitaireTableData=res.data
        } else {
          this.$message({
            message:res.message,
            type: 'error'
          });
          this.loading=false
        }
      })
    },
    saveSolitaire() {
      const crossShopNames = [...new Set(this.solitaireTableData
        .filter(row => (row.warnings || []).some(warning => warning.indexOf('[跨店]') >= 0))
        .map(row => row.providerName)
        .filter(Boolean))]
      if (crossShopNames.length > 0) {
        this.$confirm(
          `${crossShopNames.join('、')} 不属于当前门店。确认是跨店支援，并将业绩计入当前门店吗？`,
          '确认跨店录入',
          {confirmButtonText: '确认保存', cancelButtonText: '返回核对', type: 'warning'}
        ).then(() => this.doSaveSolitaire()).catch(() => {})
        return
      }
      this.doSaveSolitaire()
    },
    doSaveSolitaire() {
      this.loading=true
      // 注释
      saveSolitaire(this.solitaireTableData).then(res => {
        if (res.code==='200') {
          this.getdata(this.formInline)
          this.loading=false
          this.importVisible=false
          this.editFormVisible=false
          this.importListVisible=false
          this.$message({
            type: 'success',
            message: '手工账目保存成功！'
          })
        } else {
          this.loading=true
          this.$message({
            message:res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('手工账目保存异常，请稍后再试！')
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    isMemberFormat(itemValue){
      for(let obj of this.isMemberEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    isNewCustomerFormat(itemValue){
      for(let obj of this.isNewCustomerEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    isFavorableCommentFormat(itemValue){
      for(let obj of this.isFavorableCommentEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    dataExport(){
      this.loading=true
      exportManualTrans(this.formInline)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'example.xlsx'); // 设置下载的文件名，如果不设置则浏览器会自动命名（可能不友好）
          document.body.appendChild(link); // 必须添加到body中才能触发下载事件
          link.click(); // 触发点击事件开始下载文件
          this.loading=false
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    dataImport(){
      this.importVisible=true;
      this.solitaireTableData=[]
    },
    uploadFalse(response, file, fileList) {
      alert("文件上传失败！");
    },
    uploadSuccess(response, file, fileList) {
      this.loading=true
      //文件导入成功
      if (response.code ===  "200") {
        this.importListVisible=true
        this.loading=false
        this.solitaireTableData=response.data
      }else {
        this.$message.success(response.message);
        this.open1 = false;
        this.loading=false
      }

    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const extension3 = file.name.split(".")[1] === "doc";
      const extension4 = file.name.split(".")[1] === "docx";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2 && !extension3 && !extension4) {
        alert("上传模板只能是 xls、xlsx、doc、docx 格式!");
      }
      if (!isLt2M) {
        console.log("上传模板大小不能超过 10MB!");
      }
      return extension || extension2 || extension3 || (extension4 && isLt2M);
    },
    handleManualTrans(row){
      this.editManualTransVisible =true
      this.editManualTransForm.manualId=row.manualId
      this.editManualTransForm.manualDate=formatDate(row.manualDate)
      this.editManualTransForm.manualStaffId=row.manualStaffId
      this.editManualTransForm.manualStaffName=row.manualStaffName
      this.editManualTransForm.manualMchId=row.manualMchId
      this.editManualTransForm.customerName=row.customerName
      this.editManualTransForm.manualCategory=row.manualCategory
      this.editManualTransForm.manualContent=row.manualContent
      this.editManualTransForm.manualAmount=row.manualAmount
      this.editManualTransForm.newCardAmount=row.newCardAmount
      this.editManualTransForm.newCardProportion=row.newCardProportion
      this.editManualTransForm.rechargeCardAmount=row.rechargeCardAmount
      this.editManualTransForm.rechargeCardProportion=row.rechargeCardProportion
      this.editManualTransForm.isMember=row.isMember
      this.editManualTransForm.isNewCustomer=row.isNewCustomer
      this.editManualTransForm.isFavorableComment=row.isFavorableComment
      this.editManualTransForm.isReorder=!!row.isReorder
      this.editManualTransForm.isDesignated=!!row.isDesignated
      this.editManualTransForm.customerSource=row.customerSource
      this.editManualTransForm.newCardTotal=row.newCardTotal
      this.editManualTransForm.rechargeCardTotal=row.rechargeCardTotal
    },
    delManualTrans(row){
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          delManualTrans(row.manualId)
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '手工记录已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('手工记录删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })

    },
    closeManualTransDialog(){
      this.editManualTransVisible =false
    },
    /**
     * 时间戳
     * @param {*} timestamp  时间戳
     */
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    submitManualTranForm(){
      this.loading=true
      // 注释
      updateManualTrans(this.editManualTransForm).then(res => {
        if (res.code==='200') {
          this.getdata(this.formInline)
          this.loading=false
          this.editManualTransVisible =false
          this.$message({
            type: 'success',
            message: '手工账目修改成功！'
          })
        } else {
          this.loading=true
          this.$message({
            message:res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('手工账目修改异常，请稍后再试！')
      })

    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>







// WEBPACK FOOTER //
// src/views/finance/ManualTrans.vue